import { useCallback } from "react";
import DropZoneView, { FileSelector } from "../components/DropZoneView";
import { PackEditorCallbacks } from "../core/EditorTypes";
import { fileProcessor } from "../FileProcessor";

type Props = {
  packEditorCallbacks: PackEditorCallbacks;
};

export const CreateOrImportPage = (props: Props) => {
  const { packEditorCallbacks } = props;
  const {
    onPackFile,
    onPackFileEvent,
    onChooseDeck,
    onChooseColumns,
    createNewPack,
  } = packEditorCallbacks;

  const onStartOpen = useCallback(() => {
    var fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".json, .zip";
    fileInput.click();

    fileInput.onchange = (event) => {
      fileProcessor(onPackFile, onPackFileEvent, {
        onChooseDeck,
        onChooseColumns,
      })(event);
      fileInput.remove();
    };

    fileInput.oncancel = () => {
      fileInput.remove();
    };
  }, [onPackFile, onPackFileEvent]);

  const onStartImportAnki = useCallback(() => {
    var fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".apkg";
    fileInput.click();

    fileInput.onchange = (event) => {
      // onPackFile(file, "anki", "apkg");
      fileProcessor(onPackFile, onPackFileEvent, {
        onChooseDeck,
        onChooseColumns,
      })(event);
      fileInput.remove();
    };

    fileInput.oncancel = () => {
      fileInput.remove();
    };
  }, [onPackFile, onPackFileEvent]);

  const onStartImportCsvOrTsv = useCallback(() => {
    var fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".csv, .tsv";
    fileInput.click();

    fileInput.onchange = (event) => {
      // onPackFile(file, "anki", "apkg");
      fileProcessor(onPackFile, onPackFileEvent, {
        onChooseDeck,
        onChooseColumns,
      })(event);
      fileInput.remove();
    };

    fileInput.oncancel = () => {
      fileInput.remove();
    };
  }, [onPackFile, onPackFileEvent]);

  // const onStartImportCsvOrTsv = useCallback(() => {
  //   var fileInput = document.createElement("input");
  //   fileInput.type = "file";
  //   fileInput.accept = ".csv, .tsv";
  //   fileInput.click();
  //   fileInput.remove();
  // }, [onPackFile, onPackFileEvent]);

  // const onStartImportLogseq = useCallback(() => {
  //   var fileInput = document.createElement("input");
  //   fileInput.type = "file";
  //   fileInput.accept = ".json";
  //   fileInput.click();
  //   fileInput.remove();
  // }, [onPackFile, onPackFileEvent]);

  return (
    <div className="imports">
      <div className="section">
        <h2>📂 Open pack</h2>
        <p className="light">
          Start with an existing pack to edit.<br />
          <strong>You can drag and drop a file anywhere into this window to open.</strong>
        </p>
        <button
          onClick={onStartOpen}
        >
          <strong>Open local file</strong> (.json, .zip)<br />
          {
            /* <FileSelector
            onFile={onPackFile}
            onFileEvent={onPackFileEvent}
            other={{ onChooseColumns, onChooseDeck }}
          /> */
          }
        </button>
        <button
          onClick={() => {
          }}
          style={{ opacity: 0.5, backgroundColor: "rgba(125, 125, 125, 0.5)" }}
        >
          <strong>Open file from phone</strong> (connect first)
        </button>
        <button
          onClick={() => {
            window.location.href = "https://optimem.org/packs";
          }}
        >
          <strong>Browse Optimem library</strong>
        </button>
      </div>
      <div className="section">
        <h2>📥 Import other formats</h2>
        <p className="light">
          Alternatively, you may import content from other apps.
        </p>
        <button onClick={onStartImportAnki}>
          {/* <span className="tiny-inline-icon-wrapper"><img src='/icons/anki-icon.svg' alt="anki icon" className="tiny-inline-icon" /></span> */}
          <strong>Import from Anki</strong> (.apkg)
        </button>
        {/* <button><strong>Import from Logseq</strong> (.json)</button> */}
        <button onClick={onStartImportCsvOrTsv}>
          <strong>Import spreadsheet</strong> (.csv, .tsv)
        </button>
      </div>
      <div className="section">
        <h2>✨ New</h2>
        <p className="light">
          If you want to start a new pack from scratch, go ahead!
        </p>
        <button onClick={createNewPack}>
          <strong>Create from scratch</strong>
        </button>
      </div>
      {
        /* <DropZoneView
        onFile={onPackFile}
        onFileEvent={onPackFileEvent}
        other={{
          onChooseDeck: onChooseDeck,
          onChooseColumns: onChooseColumns,
        }}
      />

      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          width: "100%",
        }}
      >
        <button
          style={{ margin: 16 }}
          className="btn"
          onClick={() => {
            // go to optimem.org/packs
            window.location.href = "https://optimem.org/packs";
          }}
        >
          Browse Optimem pack library
        </button>
        <button
          style={{ margin: 16 }}
          className="btn"
          onClick={createNewPack}
        >
          Create new pack from scratch
        </button> */
      }
      {/* </div> */}
    </div>
  );
};
